namespace appn.ui {

    export let formExpansionHelper = {
        init: init,
        registerHandler: registerExpansionHandler
    };

    var focusEnabled = false;
    var expansionHandlers = {
        common: {
            open: function(key, $link, $expansion) {
                if ($link.data('expansion-upgrade-required')) {
                    $('#upgradeReqd').modal('show');
                    return;
                }

                // find link partner in quick-access buttons
                const header = $($link).closest('.card-header');
                const actions = header.find('.card-tools ' + ($link.prop('tagName') !== 'A' ? 'button' : 'a'));

                if (actions.length > 0)
                    actions.each((index, action) => {
                        if ($(action).data('expansion-link') === $link.data('expansion-link')) {
                            $(action).hideElement();
                        }
                    });

                $expansion.showElement();
                $link.hideElement();

                var $closeLink = $expansion.closest('.connector')
                    .find('[data-expansion-link="' + key + '"][data-expansion-actions*="close"]');
                $closeLink.showElement();

                if (focusEnabled) {
                    // Focus field after opening if a focus selector was specified
                    var focusSelector = $link.data('expansion-focus');
                    if (focusSelector !== undefined && focusSelector.length != -1)
                        $expansion.find(focusSelector).focus();
                }
            },
            close: function(key, $link, $expansion) {
                $link.hideElement();
                $expansion.hideElement();
                $expansion.find('input').val('');
                var $openLink = $expansion.closest('.connector').find('[data-expansion-link="' + key + '"][data-expansion-actions*="open"]');
                $openLink.showElement();
            },
            clear: function(key, $link, $expansion) {
                $expansion.find('input').val('');
            },
            toggle: function(key, $link, $expansion) {
                var toggleKey = $link.data('expansion-toggle');
                var $toggleLink = $expansion.closest('.connector').find('[data-expansion-link="' + toggleKey + '"]');
                var $toggleExpansion = $expansion.closest('.connector').find('[data-expansion="' + toggleKey + '"]');

                $link.hideElement();
                $expansion.showElement();
                $toggleLink.showElement();
                $toggleExpansion.hideElement();
            }
        }
    };

    function init(scopeSelector) {
        // bind the data expansion link click handler to the connector div.
        // This is so that expansion links that are dynamically created within the connector div will be bound as well.
        // A click on the expansion link bubbles up to the connector div and is dispatched from there.
        $(scopeSelector).on('click', '[data-expansion-link]', function() {
            var $link = $(this);
            var key = $link.data('expansion-link');
            var actions = $link.data('expansion-actions').split(' ');
            var $expansion = $('[data-expansion="' + key + '"]');

            if (actions.length === 0)
                throw new Error('Elements with a data-expansion-link has to contain a data-expansion-action attribute that lists space separated actions to execute on click. To view the available actions see the expansionHandlers object. Overrides to default action behaviour can be specified using the data-expansion-handler attribute if the handler is defined in the root level of expansionHandlers.');

            // find the handler for each action and execute them in order listed
            $.each(actions, function(idx, action) {
                var actionHandler: any = null;
                var handlerName = 'common';

                var parts = action.split('.');
                if (parts.length === 2) {
                    action = parts[1];
                    handlerName = parts[0];
                }

                // first look for specific implementation
                if (handlerName !== undefined && handlerName !== null && handlerName.length !== 0) {
                    if (expansionHandlers[handlerName] === undefined)
                        throw new Error('expansionHandlers.' + handlerName + ' was not registered. You have to register a handler with FormExpansionHelper.registerHandler in order to use it with the data-expansion-actions attribute.');

                    if (expansionHandlers[handlerName][action] !== undefined)
                        actionHandler = expansionHandlers[handlerName][action];
                }
                // then look for a common implementation
                if (actionHandler === null && expansionHandlers.common[action] !== undefined)
                    actionHandler = expansionHandlers.common[action] as () => void;

                if (actionHandler !== null) {
                    actionHandler(key, $link, $expansion);
                } else {
                    throw new Error('Action is not defined in common handlers or any registered handlers. All actions specified with data-expansion-actions attribute must be defined in expansionHandlers.common or registered with FormExpansionHelper.registerHandler when using the handler.action format.');
                }
            });
        });

        $('[data-expansion-click-on-load="true"]').click();

        appn.select.init({ selector: '.connector select.httpVerb,.connector select.formatType', omitWidth: true });
    }

    function registerExpansionHandler(name, registerDelegate) {
        expansionHandlers[name] = registerDelegate(expansionHandlers.common);
    }
}
